<script lang="ts">
  import { getPlacePredictions, getPlaceDetails } from "../lib/helpers/places";
  import type {
    PlaceResult,
    AutocompletePrediction,
  } from "../lib/google/maps/types";
  import PredictionItem from "./PredictionItem.svelte";

  export let placeholder: string;
  export let onPlaceSelected: (place: PlaceResult) => void;
  export let invalidMessage: string | undefined = undefined;
  export let value = "";

  $: addressDescription = value;
  let isLoading = false;
  let predictionResults: Array<AutocompletePrediction> = [];

  // TODO: need some kind of loader for when fetching the place details...
  const googlePredictionSelected = async (
    prediction: AutocompletePrediction
  ) => {
    const selectedPlace = await getPlaceDetails(prediction.place_id);
    onPlaceSelected(selectedPlace);
    addressDescription = selectedPlace.formatted_address || "";
    predictionResults = [];
  };

  const onInput = async (evt: HTMLInputElement) => {
    const value = evt.target.value;
    isLoading = true;
    if (value) {
      predictionResults = await getPlacePredictions(value);
    }
    isLoading = false;
  };

  $: predictions = predictionResults;
</script>

<div class="relative">
  <input
    required
    bind:value={addressDescription}
    on:input={(evt) => onInput(evt)}
    name="place"
    type="text"
    placeholder={placeholder}
    class="bg-primary-off-white py-5 md:py-3.5 px-6 md:px-8 font-normal rounded-lg placeholder:text-black text-base outline-none w-full"
  />
  {#if predictions.length > 0}
    <div
      class="dropdown absolute top-18 left-0 rounded-lg drop-shadow-md z-10 bg-white py-3 px-2 max-w-96"
    >
      {#each predictions as prediction}
        <PredictionItem
          {prediction}
          predictionSelected={googlePredictionSelected}
        />
      {/each}
    </div>
  {/if}
</div>
